import getApi from '@/lib/axios';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function get_evolucao_inadimplencia(params={}): Promise<ConsolidationSummaryType> {
  const api = await getApi();

  const { data } = await api.get<ConsolidationSummaryType>('/financeiro/get_evolucao_inadimplencia/', { params });
  return data;
}

export { get_evolucao_inadimplencia };
